import React, { Component } from 'react';
import { Text } from 'core/components';
import { CardSkeleton, ProductSkeleton } from 'core/components/Skeletons';

class LoadingSkeleton extends Component {
  static defaultProps = {
    height: '100%',
    width: '100%',
    style: {}
  };

  render() {
    const { loadingText, height, width, style } = this.props;

    return (
      <CardSkeleton style={{ height, width, ...style }}>
        <ProductSkeleton width="50%" />
        <ProductSkeleton width="70%" />
        {loadingText && (
          <Text small muted>
            {loadingText}
          </Text>
        )}
        <ProductSkeleton width="40%" />
        <ProductSkeleton width="80%" />
      </CardSkeleton>
    );
  }
}

export default LoadingSkeleton;
